<template>
  <v-container
    class="odash pl-md-8 pr-md-8"
    fluid
  >
    <template v-if="statistics">
      <v-row
        v-for="(stat, statIdx) in statistics"
        :key="statIdx"
        class="odash-ind"
      >
        <v-col
          cols="12"
          sm="4"
        >
          <v-card dark>
            <v-card-text>
              Total Atendimentos Táticos / Ano
            </v-card-text>
            <v-card-title>
              {{ stat.totalTaticoAtendido }}
            </v-card-title>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-card dark>
            <v-card-text>
              Ordens de serviço atendidas / Ano
            </v-card-text>
            <v-card-title>
              {{ stat.totalOsAtendidas }}
            </v-card-title>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-card dark>
            <v-card-text>
              Número de Desvios de hábito / Ano
            </v-card-text>
            <v-card-title>
              {{ stat.totalDesvioHabito }}
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-for="(stat, statIdx) in statistics"
        :key="statIdx"
        class="odash-ind"
        align="center"
        style="margin-top: 40px;"
      >
        <v-col
          cols="9"
          md="6"
          offset-md="3"
          style="font-size: big;"
        >
         <v-input label="">

                <br><b>PATRIMÔNIO : </b> {{ stat.endereco }} + {{ stat.bairro }} + {{ stat.cidade }}
              </v-input> 
        </v-col>
        <v-col
          cols="3"
          md="2"
          class="text-right text-md-left odash-leg"
        >
          <span>Legenda:</span>
          <span class="odash-leg-time">Tempo</span>
        </v-col>
      </v-row>
      <!-- Charts -->
      <v-row
        v-if="searchResults && searchResults.length > 0"
        class="odash-charts"
      >
        <v-col
          v-for="(res, resIdx) in searchResults"
          :key="resIdx"
          cols="12"
          :sm="resIdx>0?resIdx + 1 % 3===0?12:6:12"
        >
          <OrsChart
            class="odash-charts-chart"
            :title="res.chart.desTipGra"
            :chart-type="res.chart.tipGra"
            :chart-data="res.chart.lisPon"
            @bullet-click="pon => openChartModal({res, pon})"
          />
        </v-col>
      </v-row>
      <v-row
        v-else
        class="d-flex flex-column align-center pt-8"
      >
        <div>Sem resultados para exibir.</div>
      </v-row>
    </template>
    <v-row
      v-else
      justify="center"
    >
      <v-progress-circular
        indeterminate
      />
    </v-row>
    <!-- Dialog -->
    <v-dialog
      :value="isDialogOpen"
      max-width="680px"
      @click:outside="setChartModalData(null)"
      @keydown="setChartModalData(null)"
    >
      <v-card
        v-if="chartModalData"
        class="odash-dg pa-4"
      >
        <v-toolbar
          flat
          style="height: 64px;background-color: #FCE300;"
        >
          <v-toolbar-title class="odash-dg-title font-weight-light primary--text">
            <b>Alarme - {{ chartModalData.statistic.fantasia.toLowerCase() }}</b>
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            text
            color="primary"
            @click="setChartModalData(null)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="d-flex align-start my-1">
            <img
              v-if="!chartModalData.pon.img || chartModalData.pon.img === 'N/A'"
              class="odash-dg-img"
              src="../assets/notebook.jpg"
            >
            <img
              v-else
              class="odash-dg-img"
              :src="chartModalData.pon.img"
            >
            <b><dl class="odash-dg-details pa-2">
              <dt>Evento: </dt>
              <dd>{{ chartModalData.pon.event }}</dd>
              <template v-if="chartModalData.pon.date">
                <dt>Ocorrido em:</dt>
                <dd>{{ chartModalData.pon.date }}</dd>
              </template>
              <template v-if="chartModalData.pon.inPlace">
                <dt>No local em:</dt>
                <dd>{{ chartModalData.pon.inPlace }}</dd>
              </template>
              <dt>Tempo:</dt>
              <dd>{{ chartModalData.pon.value }} min</dd>
              <dt v-if="chartModalData.pon.by">
                Atendido por:
              </dt>
              <dd>{{ chartModalData.pon.by }}</dd>
            </dl></b>
          </div>
          <template v-if="chartModalData.pon.info">
            <hr class="my-4">
            <div class="odash-dg-info">
              <div class="primary--text">
                Informações
              </div>
              {{ chartModalData.pon.info }}
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex';
import OrsChart from '@/components/OrsChart.vue';
import debounce from '@/lib/debounce';

const dash = createNamespacedHelpers('views/dashboard');
const session = createNamespacedHelpers('session');
const login = createNamespacedHelpers('login');

export default {
  name: 'Dashboard',
  components: {
    OrsChart,
  },
  data: () => ({
    statisticsLoader: null,
  }),
  computed: {
    ...dash.mapState([
      'statistics',
      'charts',
      'searchInput',
      'chartModalData',
      'totalTaticoAtendido',
      'totalOsAtendidas',
      'totalDesvioHabito',
    ]),
    ...dash.mapGetters([
      'searchItems',
      'searchResults',
      'isDialogOpen',
    ]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const options = { from, goToInvoices: vm.goToInvoices };
      vm.statisticsLoader = () => vm.loadStatistics(options);
      vm.statisticsLoader();
      vm.addAccountChangeListener(vm.statisticsLoader);
      vm.setOverlay(false);
    });
    
  },
  beforeRouteLeave(to, from, next) {
    this.removeAccountChangeListener(this.statisticsLoader);
    next();
  },
  methods: {
    ...dash.mapActions([
      'loadStatistics',
      'search',
      'openChartModal',
    ]),
    ...dash.mapMutations([
      'setChartModalData',
    ]),
    ...session.mapMutations([
      'addAccountChangeListener',
      'removeAccountChangeListener',
    ]),
    ...login.mapActions([
      'setOverlay'
    ]),
    debSearch: debounce(
      dash.mapActions(['search']).search,
      300,
    ),
    goToInvoices() {
      const canGoToInvoice = this.$store.getters['app/userMenu'].find(menu => menu.featureId === 1);
      if (canGoToInvoice) {
        this.$router.push({ name: 'invoices' });
      } else {
        this.$router.push({ name: 'Blank' });
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.odash {
  .odash-ind {
    /deep/ > div {
      &:nth-child(1n) .v-card {
        background-color: var(--dash-color-1);
      }

      &:nth-child(2n) .v-card {
        background-color: var(--dash-color-2);
      }

      &:nth-child(3n) .v-card {
        background-color: var(--dash-color-3);
      }
    }
    /deep/ .v-card {
      .v-card__text,
      .v-card__title {
        font-weight: bold;
        justify-content: center;
        text-align: center;
      }

      .v-card__text {
        padding-bottom: 8px;
      }

      .v-card__title {
        padding: 16px;
        padding-top: 8px;
        font-size: 2em;
      }
    }
  }
  .odash-search {
    .odash-search-combo /deep/ {
      .v-input__slot {
        margin-bottom: 0;
      }

      .v-text-field__details {
        display: none;
      }
    }
  }
  .odash-leg {
    font-size: .75em;
    font-weight: bold;
    color: var(--other-color-1);

    .odash-leg-time {
      font-size: .825em;
      position:  relative;
      margin-left: 10px;
    }
    .odash-leg-time:before {
        content: '';
        position:  absolute;
        width: 110%;
        height:  1px;
        top: -3px;
        left: -5%;
        border-top: 1px solid;
    }
    .odash-leg-time:after {
        content:  '';
        position:  absolute;
        background-color: #000;
        border-radius: 50%;
        width: 7px;
        height: 7px;
        left: calc(50% - 3px);
        top: -6px;
    }
  }
}

.odash-dg {
  .odash-dg-title {
    text-transform: capitalize;
  }
  .odash-dg-img {
    max-width: 105px;
    width: 100%;
    height: auto;
  }
  .odash-dg-details {
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 1em;

    dt {
      color: var(--primary-color-3);
    }
  }
  .odash-dg-info {
    white-space: pre-line;
  }
}

</style>
